import { z } from 'zod';

export const MESSAGE_FEEDBACK_RATINGS = ['up', 'down'] as const;
export const MESSAGE_FEEDBACK_REASONS = [
  'incorrect_answer',
  'incorrect_citation',
  'missing_information',
  'not_helpful',
  'other',
] as const;
export const MESSAGE_FEEDBACK_COMMENT_MAX_LENGTH = 1000;

export const messageFeedbackRatingSchema = z.enum(MESSAGE_FEEDBACK_RATINGS, {
  error: 'L’appréciation est invalide.',
});
export const messageFeedbackReasonSchema = z.enum(MESSAGE_FEEDBACK_REASONS, {
  error: 'Le motif de retour est invalide.',
});

/** A reader's opinion of one assistant answer; a reason only qualifies a negative rating. */
export const upsertMessageFeedbackSchema = z.object({
  comment: z.string().trim().max(MESSAGE_FEEDBACK_COMMENT_MAX_LENGTH, {
    error: 'Le commentaire est trop long.',
  }).optional().transform((value) => value || undefined),
  rating: messageFeedbackRatingSchema,
  reason: messageFeedbackReasonSchema.optional(),
}).superRefine((input, context) => {
  if (input.rating === 'up' && (input.reason || input.comment)) {
    context.addIssue({
      code: 'custom',
      message: 'Un retour positif ne porte ni motif ni commentaire.',
      path: ['reason'],
    });
  }
});

export const messageFeedbackSchema = z.object({
  messageId: z.uuid(),
  rating: messageFeedbackRatingSchema,
  reason: messageFeedbackReasonSchema.nullable(),
});

export const conversationFeedbackListSchema = z.object({
  items: z.array(messageFeedbackSchema),
});

export type MessageFeedbackRating = z.infer<typeof messageFeedbackRatingSchema>;
export type MessageFeedbackReason = z.infer<typeof messageFeedbackReasonSchema>;
export type UpsertMessageFeedbackDTO = z.infer<typeof upsertMessageFeedbackSchema>;
/** Request body as sent by clients (before trimming). */
export type UpsertMessageFeedbackInput = z.input<typeof upsertMessageFeedbackSchema>;
export type MessageFeedbackDTO = z.infer<typeof messageFeedbackSchema>;
export type ConversationFeedbackListDTO = z.infer<typeof conversationFeedbackListSchema>;
